import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SvgImage from '../svg-image';

const Anchor = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 4rem;

	img {
		max-width: 3rem;
	}
`;

const PixwelLogo = styled(SvgImage)`
	width: ${({ isMaximized }) => isMaximized ? '6.75rem' : '2.5rem'};
	height: ${({ isMaximized }) => isMaximized ? '3rem' : '2.5rem'};
`;

function MenuLogo(props) {
	const {
		logo,
		isMaximized
	} = props;

	const showPixwelLogo = logo === '/img/pixwel.logo.png';

	return (
		<Anchor href="/">
			{showPixwelLogo
				? (
					<PixwelLogo
						use={`pixwel${isMaximized ? 'Lg' : 'Sm'}`}
						isMaximized={isMaximized}
					/>
				)
				: (
					<img src={logo} />
				)}
		</Anchor>
	);
}

MenuLogo.propTypes = {
	logo: PropTypes.string.isRequired,
	isMaximized: PropTypes.bool
};

export default MenuLogo;
